/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IProgramsSummary {
  /** Тип льготной программы **/
  benefitProgram: EBenefitProgram;
  /** Название программы **/
  title: string;
  /** Ставка (текст для отображения) **/
  rate: string;
  /** Срок кредита (текст для отображения) **/
  loanTerm: string;
  /** Сумма кредита (текст для отображения) **/
  loanAmount: string;
  /** Первоначальный взнос (текст для отображения) **/
  downPayment: string;
}

export enum EBenefitProgram {
  /** Базовая **/
  'NoProgram' = 'noProgram',
  /** Господдержка 2020 **/
  'GovernmentSupport2020' = 'governmentSupport2020',
  /** Семейная **/
  'Family' = 'family',
  /** ИТ-ипотека **/
  'It' = 'it',
  /** ИЖС ХОЗСПОСОБОМ **/
  'IzhsHozsposopom' = 'izhsHozsposopom',
}
